var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportRequestPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1469 13.3C12.7969 13.3 11.6969 12.8 10.6969 11.85C9.69687 10.9 9.24687 9.75001 9.24687 8.40001C9.24687 7.05001 9.74687 5.95001 10.6969 4.95001C11.6469 3.95001 12.7969 3.50001 14.1469 3.50001C15.4969 3.50001 16.5969 4.00001 17.5969 4.95001C18.5469 5.90001 19.0469 7.05001 19.0469 8.40001C19.0469 9.75001 18.5469 10.85 17.5969 11.85C16.5969 12.8 15.4469 13.3 14.1469 13.3ZM15.9969 10.95L16.6969 10.25L14.5969 8.35001V5.20001H13.4969V8.65001L15.9969 10.95ZM15.9469 13.9V15.3H11.2469L9.04688 17.5L6.84688 15.3H2.14688V1.55001H15.9469V2.95001C16.4469 3.10001 16.8969 3.35001 17.3469 3.65001V1.55001C17.3469 1.20001 17.1969 0.85001 16.8969 0.60001C16.5969 0.30001 16.2969 0.20001 15.9469 0.20001H2.19687C1.79687 0.15001 1.49687 0.30001 1.19687 0.55001C0.946875 0.85001 0.796875 1.15001 0.796875 1.55001V15.35C0.796875 15.7 0.946875 16 1.19687 16.3C1.49687 16.6 1.79688 16.75 2.14688 16.75H6.29688L9.04688 19.5L11.7969 16.75H15.9469C16.2969 16.75 16.5969 16.6 16.8969 16.3C17.1969 16 17.3469 15.7 17.3469 15.35V13.25C16.8969 13.5 16.4469 13.75 15.9469 13.9Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportRequestPurpleIcon);
export default __webpack_public_path__ + "static/media/supportRequestPurpleIcon.03dc43bdb71623d9a39b271fe5bc5cd7.svg";
export { ForwardRef as ReactComponent };